import React,{ useEffect } from "react"
import { useNavigate } from "react-router-dom"

const Redirect=({to})=>{
    const Navigate = useNavigate();
    useEffect(()=>{
        Navigate(to, {replace:true});
    },[]);
}
export default Redirect;